const style = {
  header: {
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    marginBottom: "48px",
    '@media(max-width:480px)':{
        fontSize:"24px",
        letterSpacing:"1px",
        fontWeight:"600",
        marginBottom: "20px",
    }
  },
  title: {
    fontSize: "24px",
    width: "100%",
    display: "flex",
    fontWeight:"600",
    justifyContent: "space-between",
    alignItems:"center",
    "& svg": {
      width: "1.5em",
      height: "1.5em",
    },
    '@media(max-width:480px)':{
        fontSize:"16px",
    }
  },
  description: {
    fontSize: "18px",
    fontWeight: "300",
    '@media(max-width:480px)':{
        fontSize:"14px",
    }
  },
  faqDivider: {
    margin: "0 0",
    borderWidth: "0",
    borderStyle: "solid",
    borderColor: "rgb(255 255 255 / 26%)",
    borderBottomWidth: "thin",
    '@media(max-width:480px)':{
      margin: "0",
    }
  },
  accordionTab:{
    '.Mui-expanded svg':{
      transform:"scaleY(-1)"
    }
  },
};
export default style;
